(function () {
  'use strict';

  function initFaq() {
    var items = document.querySelectorAll('.faq-item');
    items.forEach(function (item, index) {
      var q = item.querySelector('.faq-q');
      var a = item.querySelector('.faq-a');
      var toggle = item.querySelector('.toggle');
      if (!q || !a) return;

      var open = index === 0;
      var apply = function () {
        a.style.display = open ? 'block' : 'none';
        if (toggle) toggle.textContent = open ? '−' : '+';
      };
      apply();

      q.addEventListener('click', function () {
        open = !open;
        apply();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
})();
